// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-27T06:56:37Z                      #

// ##############################################################

// @ts-ignore - not used import
import {AxiosInstance, AxiosResponse, AxiosRequestConfig, CancelToken} from 'axios';
// @ts-ignore - not used import
import {unwrapResponse, generateUrl, baseAxios} from '@mc/axios-api';
// @ts-ignore - not used import
import * as importUrl from 'url';
// @ts-ignore - not used import
import FulltextVO from "./types/FulltextVO";
// @ts-ignore - not used import
import MailTemplateDetailVO from "./types/MailTemplateDetailVO";
// @ts-ignore - not used import
import SignerVO from "./types/SignerVO";
// @ts-ignore - not used import
import ConfigurationVO from "./types/ConfigurationVO";
// @ts-ignore - not used import
import MailTemplateVO from "./types/MailTemplateVO";
// @ts-ignore - not used import
import FlowConfigurationVO from "./types/FlowConfigurationVO";
// @ts-ignore - not used import
import SignConnectorVO from "./types/SignConnectorVO";
// @ts-ignore - not used import
import TypesCombinationVO from "./types/TypesCombinationVO";
// @ts-ignore - not used import
import SealConnectorVO from "./types/SealConnectorVO";
// @ts-ignore - not used import
import ConfigApproverVO from "./types/ConfigApproverVO";
// @ts-ignore - not used import
import TextNoteVO from "./types/TextNoteVO";
// @ts-ignore - not used import
import AdminAccessRoleVO from "./types/AdminAccessRoleVO";

// @ts-ignore - not used import
import * as UpdateMethods from "./UpdateMethods";


// @ts-ignore - not used import
type SimpleHeaders = {[key: string]: string};

/**
 *  Generated from cz.marbes.qsign.controller.QSignAdminController.
 */
export default class QSignAdminApi {
    /**
     * Vytvoření nového podepisujícího.
     *
     * @param signer podepisující
     * @return vytvořený podepisující
     */
    static createSigner(signer : SignerVO, config?: {cancelToken?: CancelToken}) : Promise<SignerVO> {
        return unwrapResponse<SignerVO>(QSignAdminApi.raw.createSigner(signer, config));
    }
    /**
     * Smazání podepisujícího.
     *
     * @param pracovnikId identifikátor mazaného pracovníka
     */
    static deleteSigner(pracovnikId : number, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(QSignAdminApi.raw.deleteSigner(pracovnikId, config));
    }
    /**
     * Smazání konektoru pro podepisování.
     *
     * @param connectorId id mazaného konektoru
     */
    static deleteSignConnector(connectorId : number, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(QSignAdminApi.raw.deleteSignConnector(connectorId, config));
    }
    /**
     * Smazání kombinace typů
     *
     * @param combinationId id mazané kombinace
     */
    static deleteTypesCombination(combinationId : number, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(QSignAdminApi.raw.deleteTypesCombination(combinationId, config));
    }
    /**
     * Získání seznamu šablon pro e-mailové notifikace.
     *
     * @return seznam šablon
     */
    static findMailTemplates(config?: {cancelToken?: CancelToken}) : Promise<MailTemplateVO[]> {
        return unwrapResponse<MailTemplateVO[]>(QSignAdminApi.raw.findMailTemplates(config));
    }
    /**
     * 
     *
     * @return 
     */
    static hasAdminAccess(config?: {cancelToken?: CancelToken}) : Promise<boolean> {
        return unwrapResponse<boolean>(QSignAdminApi.raw.hasAdminAccess(config));
    }
    /**
     * Aktualizace konfigurace.
     *
     * @param configurationId identifikátor aktualizované konfigurace
     * @param configuration parametry konfigurace
     * @return upravená konfigurace
     */
    static updateFlowConfiguration(configurationId : number, configuration : FlowConfigurationVO, config?: {cancelToken?: CancelToken}) : Promise<FlowConfigurationVO> {
        return unwrapResponse<FlowConfigurationVO>(QSignAdminApi.raw.updateFlowConfiguration(configurationId, configuration, config));
    }
    /**
     * Vyhledání ID všech podepisujících podle zadaného fulltextu.
     *
     * @param fulltextVO 
     * @return seznam ID podepisujících pracovníků
     */
    static findSignerIds(fulltextVO : FulltextVO, config?: {cancelToken?: CancelToken}) : Promise<number[]> {
        return unwrapResponse<number[]>(QSignAdminApi.raw.findSignerIds(fulltextVO, config));
    }
    /**
     * Smazání konfigurace.
     *
     * @param configurationId identifikátor mazané konfigurace
     */
    static deleteConfiguration(configurationId : number, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(QSignAdminApi.raw.deleteConfiguration(configurationId, config));
    }
    /**
     * Aktualizace konfigurace.
     *
     * @param configurationId identifikátor aktualizované konfigurace
     * @param configuration parametry konfigurace
     * @return upravená konfigurace
     */
    static updateConfiguration(configurationId : number, configuration : ConfigurationVO, config?: {cancelToken?: CancelToken}) : Promise<ConfigurationVO> {
        return unwrapResponse<ConfigurationVO>(QSignAdminApi.raw.updateConfiguration(configurationId, configuration, config));
    }
    /**
     * Vyhledá dostupné konektory pro pečetění.
     *
     * @return konektory pro pečetění
     */
    static findSealConnectors(config?: {cancelToken?: CancelToken}) : Promise<SealConnectorVO[]> {
        return unwrapResponse<SealConnectorVO[]>(QSignAdminApi.raw.findSealConnectors(config));
    }
    /**
     * Aktualizace šablony e-mailu.
     *
     * @param id identifikátor šablony
     * @param mailTemplateDetail detail šablony e-mailu
     */
    static updateMailTemplate(id : string, mailTemplateDetail : MailTemplateDetailVO, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(QSignAdminApi.raw.updateMailTemplate(id, mailTemplateDetail, config));
    }
    /**
     * Smazání konfigurace.
     *
     * @param configurationId identifikátor mazané konfigurace
     */
    static deleteFlowConfiguration(configurationId : number, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(QSignAdminApi.raw.deleteFlowConfiguration(configurationId, config));
    }
    /**
     * Úprava podepisujícího pracovníka.
     *
     * @param pracovnikId identifikátor upravovaného pracovníka
     * @param signer upravovaný pracovník
     * @return upravený pracovník
     */
    static updateSigner(pracovnikId : number, signer : SignerVO, config?: {cancelToken?: CancelToken}) : Promise<SignerVO> {
        return unwrapResponse<SignerVO>(QSignAdminApi.raw.updateSigner(pracovnikId, signer, config));
    }
    /**
     * Vyhledání všech podepisujících podle zadaného fulltextu
     *
     * @param fulltextVO 
     * @return podepisující pracovníci
     */
    static findSigners(fulltextVO : FulltextVO, config?: {cancelToken?: CancelToken}) : Promise<SignerVO[]> {
        return unwrapResponse<SignerVO[]>(QSignAdminApi.raw.findSigners(fulltextVO, config));
    }
    /**
     * Aktualizace konektoru podepisovani
     *
     * @param signConnectorVO parametry konektoru
     * @return upravený konektor
     */
    static updateSignConnector(signConnectorVO : SignConnectorVO, config?: {cancelToken?: CancelToken}) : Promise<SignConnectorVO> {
        return unwrapResponse<SignConnectorVO>(QSignAdminApi.raw.updateSignConnector(signConnectorVO, config));
    }
    /**
     * Vyhledání všech konfigurací.
     *
     * @return konfigurace
     */
    static findFlowConfigurations(config?: {cancelToken?: CancelToken}) : Promise<FlowConfigurationVO[]> {
        return unwrapResponse<FlowConfigurationVO[]>(QSignAdminApi.raw.findFlowConfigurations(config));
    }
    /**
     * Vyhledání všech poznámek z knihovny textů.
     *
     * @return všechny poznámky
     */
    static findTextNotes(config?: {cancelToken?: CancelToken}) : Promise<TextNoteVO[]> {
        return unwrapResponse<TextNoteVO[]>(QSignAdminApi.raw.findTextNotes(config));
    }
    /**
     * Založení nové poznámky.
     *
     * @param textNote poznámka
     * @return založená poznámka
     */
    static createTextNote(textNote : TextNoteVO, config?: {cancelToken?: CancelToken}) : Promise<TextNoteVO> {
        return unwrapResponse<TextNoteVO>(QSignAdminApi.raw.createTextNote(textNote, config));
    }
    /**
     * Získání detailu šablony e-mailu.
     *
     * @param id identifikátor šablony
     * @return detail šablony
     */
    static getMailTemplateDetail(id : string, config?: {cancelToken?: CancelToken}) : Promise<MailTemplateDetailVO> {
        return unwrapResponse<MailTemplateDetailVO>(QSignAdminApi.raw.getMailTemplateDetail(id, config));
    }
    /**
     * Aktualizace kombinace typů
     *
     * @param typesCombinationVO parametry kombinace
     * @return upravená kombinace
     */
    static updateTypesCombination(typesCombinationVO : TypesCombinationVO, config?: {cancelToken?: CancelToken}) : Promise<TypesCombinationVO> {
        return unwrapResponse<TypesCombinationVO>(QSignAdminApi.raw.updateTypesCombination(typesCombinationVO, config));
    }
    /**
     * Vytvoří nový konektor pro podepisování
     *
     * @param signConnectorVO 
     * @return 
     */
    static addSignConnector(signConnectorVO : SignConnectorVO, config?: {cancelToken?: CancelToken}) : Promise<SignConnectorVO> {
        return unwrapResponse<SignConnectorVO>(QSignAdminApi.raw.addSignConnector(signConnectorVO, config));
    }
    /**
     * 
     *
     * @param adminRole obsahuje roli, kterou chci nastavit
     */
    static setAdminAccessRole(adminRole : AdminAccessRoleVO, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(QSignAdminApi.raw.setAdminAccessRole(adminRole, config));
    }
    /**
     * Vyhledání všech schvalovatele.
     *
     * @return schvalující pracovníci
     */
    static findApprovers(config?: {cancelToken?: CancelToken}) : Promise<ConfigApproverVO[]> {
        return unwrapResponse<ConfigApproverVO[]>(QSignAdminApi.raw.findApprovers(config));
    }
    /**
     * Smazání konektoru pro pečetění
     *
     * @param connectorId id mazaného konektoru
     */
    static deleteSealConnector(connectorId : number, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(QSignAdminApi.raw.deleteSealConnector(connectorId, config));
    }
    /**
     * Aktualizace konektoru pečetení
     *
     * @param sealConnectorVO parametry konektoru
     * @return upravený konektor
     */
    static updateSealConnector(sealConnectorVO : SealConnectorVO, config?: {cancelToken?: CancelToken}) : Promise<SealConnectorVO> {
        return unwrapResponse<SealConnectorVO>(QSignAdminApi.raw.updateSealConnector(sealConnectorVO, config));
    }
    /**
     * Založení nové konfigurace.
     *
     * @param configuration parametry konfigurace
     * @return založená konfigurace
     */
    static createConfiguration(configuration : ConfigurationVO, config?: {cancelToken?: CancelToken}) : Promise<ConfigurationVO> {
        return unwrapResponse<ConfigurationVO>(QSignAdminApi.raw.createConfiguration(configuration, config));
    }
    /**
     * Vytvoří novou kombinaci typů.
     *
     * @param typesCombinationVO 
     * @return vzniklá kombinace
     */
    static addTypesCombination(typesCombinationVO : TypesCombinationVO, config?: {cancelToken?: CancelToken}) : Promise<TypesCombinationVO> {
        return unwrapResponse<TypesCombinationVO>(QSignAdminApi.raw.addTypesCombination(typesCombinationVO, config));
    }
    /**
     * Vyhledání všech konfigurací.
     *
     * @return konfigurace
     */
    static findConfigurations(config?: {cancelToken?: CancelToken}) : Promise<ConfigurationVO[]> {
        return unwrapResponse<ConfigurationVO[]>(QSignAdminApi.raw.findConfigurations(config));
    }
    /**
     * Vyhledá dostupné konektory pro podepisování.
     *
     * @return konektory pro podepisování
     */
    static findSignConnectors(config?: {cancelToken?: CancelToken}) : Promise<SignConnectorVO[]> {
        return unwrapResponse<SignConnectorVO[]>(QSignAdminApi.raw.findSignConnectors(config));
    }
    /**
     * Smazání poznámku.
     *
     * @param textNoteId identifikátor mazané poznámku
     */
    static deleteTextNote(textNoteId : number, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(QSignAdminApi.raw.deleteTextNote(textNoteId, config));
    }
    /**
     * Založení nové konfigurace.
     *
     * @param configuration parametry konfigurace
     * @return založená konfigurace
     */
    static createFlowConfiguration(configuration : FlowConfigurationVO, config?: {cancelToken?: CancelToken}) : Promise<FlowConfigurationVO> {
        return unwrapResponse<FlowConfigurationVO>(QSignAdminApi.raw.createFlowConfiguration(configuration, config));
    }
    /**
     * Vyhledá dostupné kombinace typů.
     *
     * @return dostupné kombinace
     */
    static getCombinations(config?: {cancelToken?: CancelToken}) : Promise<TypesCombinationVO[]> {
        return unwrapResponse<TypesCombinationVO[]>(QSignAdminApi.raw.getCombinations(config));
    }
    /**
     * Vytvoří nový konektor pro pečetění
     *
     * @param sealConnectorVO 
     * @return 
     */
    static addSealConnector(sealConnectorVO : SealConnectorVO, config?: {cancelToken?: CancelToken}) : Promise<SealConnectorVO> {
        return unwrapResponse<SealConnectorVO>(QSignAdminApi.raw.addSealConnector(sealConnectorVO, config));
    }
    /**
     * Vyhledání ID všech podepisujících podle zadaného fulltextu.
     *
     * @param ids 
     * @return seznam ID podepisujících pracovníků
     */
    static findSignerByIds(ids : number[], config?: {cancelToken?: CancelToken}) : Promise<SignerVO[]> {
        return unwrapResponse<SignerVO[]>(QSignAdminApi.raw.findSignerByIds(ids, config));
    }
    /**
     * Aktualizace poznámky.
     *
     * @param textNoteId identifikátor aktualizované poznámky
     * @param textNote poznámka
     * @return upravená poznámka
     */
    static updateTextNote(textNoteId : number, textNote : TextNoteVO, config?: {cancelToken?: CancelToken}) : Promise<TextNoteVO> {
        return unwrapResponse<TextNoteVO>(QSignAdminApi.raw.updateTextNote(textNoteId, textNote, config));
    }

    static raw = {
            createSigner: function(signer : SignerVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SignerVO>> {
                const uri = `/qsign/api/admin/signers`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<SignerVO>>(finalUri, UpdateMethods.updateSignerVO_993E48(signer), finalConfig);
            },
            deleteSigner: function(pracovnikId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/admin/signers/${pracovnikId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.delete<any, any>(finalUri, finalConfig);
            },
            deleteSignConnector: function(connectorId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/admin/deleteSignConnector/${connectorId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.delete<any, any>(finalUri, finalConfig);
            },
            deleteTypesCombination: function(combinationId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/admin/deleteTypesCombination/${combinationId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.delete<any, any>(finalUri, finalConfig);
            },
            findMailTemplates: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<MailTemplateVO[]>> {
                const uri = `/qsign/api/admin/templates`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<MailTemplateVO[]>>(finalUri, finalConfig);
            },
            hasAdminAccess: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<boolean>> {
                const uri = `/qsign/api/admin/hasAdminAccess`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<boolean>>(finalUri, finalConfig);
            },
            updateFlowConfiguration: function(configurationId : number, configuration : FlowConfigurationVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<FlowConfigurationVO>> {
                const uri = `/qsign/api/admin/flowConfigurations/${configurationId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.put<any, AxiosResponse<FlowConfigurationVO>>(finalUri, configuration, finalConfig);
            },
            findSignerIds: function(fulltextVO : FulltextVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<number[]>> {
                const uri = `/qsign/api/admin/signers/ids`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<number[]>>(finalUri, fulltextVO, finalConfig);
            },
            deleteConfiguration: function(configurationId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/admin/configurations/${configurationId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.delete<any, any>(finalUri, finalConfig);
            },
            updateConfiguration: function(configurationId : number, configuration : ConfigurationVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<ConfigurationVO>> {
                const uri = `/qsign/api/admin/configurations/${configurationId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.put<any, AxiosResponse<ConfigurationVO>>(finalUri, UpdateMethods.updateConfigurationVO_EF85C0(configuration), finalConfig);
            },
            findSealConnectors: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SealConnectorVO[]>> {
                const uri = `/qsign/api/admin/sealConnectors`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<SealConnectorVO[]>>(finalUri, finalConfig);
            },
            updateMailTemplate: function(id : string, mailTemplateDetail : MailTemplateDetailVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/admin/templates/${id}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.put<any, any>(finalUri, mailTemplateDetail, finalConfig);
            },
            deleteFlowConfiguration: function(configurationId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/admin/flowConfigurations/${configurationId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.delete<any, any>(finalUri, finalConfig);
            },
            updateSigner: function(pracovnikId : number, signer : SignerVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SignerVO>> {
                const uri = `/qsign/api/admin/signers/${pracovnikId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.put<any, AxiosResponse<SignerVO>>(finalUri, UpdateMethods.updateSignerVO_993E48(signer), finalConfig);
            },
            findSigners: function(fulltextVO : FulltextVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SignerVO[]>> {
                const uri = `/qsign/api/admin/signers/fulltext`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<SignerVO[]>>(finalUri, fulltextVO, finalConfig);
            },
            updateSignConnector: function(signConnectorVO : SignConnectorVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SignConnectorVO>> {
                const uri = `/qsign/api/admin/updateSignConnector/`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<SignConnectorVO>>(finalUri, signConnectorVO, finalConfig);
            },
            findFlowConfigurations: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<FlowConfigurationVO[]>> {
                const uri = `/qsign/api/admin/flowConfigurations`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<FlowConfigurationVO[]>>(finalUri, finalConfig);
            },
            findTextNotes: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<TextNoteVO[]>> {
                const uri = `/qsign/api/admin/textnotes`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<TextNoteVO[]>>(finalUri, finalConfig);
            },
            createTextNote: function(textNote : TextNoteVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<TextNoteVO>> {
                const uri = `/qsign/api/admin/textnotes`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<TextNoteVO>>(finalUri, textNote, finalConfig);
            },
            getMailTemplateDetail: function(id : string, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<MailTemplateDetailVO>> {
                const uri = `/qsign/api/admin/templates/${id}/detail`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<MailTemplateDetailVO>>(finalUri, finalConfig);
            },
            updateTypesCombination: function(typesCombinationVO : TypesCombinationVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<TypesCombinationVO>> {
                const uri = `/qsign/api/admin/updateTypesCombination/`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<TypesCombinationVO>>(finalUri, typesCombinationVO, finalConfig);
            },
            addSignConnector: function(signConnectorVO : SignConnectorVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SignConnectorVO>> {
                const uri = `/qsign/api/admin/addSignConnector`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<SignConnectorVO>>(finalUri, signConnectorVO, finalConfig);
            },
            setAdminAccessRole: function(adminRole : AdminAccessRoleVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/admin/setAdminAccessRole`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, adminRole, finalConfig);
            },
            findApprovers: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<ConfigApproverVO[]>> {
                const uri = `/qsign/api/admin/approvers`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<ConfigApproverVO[]>>(finalUri, finalConfig);
            },
            deleteSealConnector: function(connectorId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/admin/deleteSealConnector/${connectorId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.delete<any, any>(finalUri, finalConfig);
            },
            updateSealConnector: function(sealConnectorVO : SealConnectorVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SealConnectorVO>> {
                const uri = `/qsign/api/admin/updateSealConnector/`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<SealConnectorVO>>(finalUri, sealConnectorVO, finalConfig);
            },
            createConfiguration: function(configuration : ConfigurationVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<ConfigurationVO>> {
                const uri = `/qsign/api/admin/configurations`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<ConfigurationVO>>(finalUri, UpdateMethods.updateConfigurationVO_EF85C0(configuration), finalConfig);
            },
            addTypesCombination: function(typesCombinationVO : TypesCombinationVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<TypesCombinationVO>> {
                const uri = `/qsign/api/admin/addCombination`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<TypesCombinationVO>>(finalUri, typesCombinationVO, finalConfig);
            },
            findConfigurations: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<ConfigurationVO[]>> {
                const uri = `/qsign/api/admin/configurations`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<ConfigurationVO[]>>(finalUri, finalConfig);
            },
            findSignConnectors: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SignConnectorVO[]>> {
                const uri = `/qsign/api/admin/signConnectors`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<SignConnectorVO[]>>(finalUri, finalConfig);
            },
            deleteTextNote: function(textNoteId : number, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/admin/textnotes/${textNoteId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.delete<any, any>(finalUri, finalConfig);
            },
            createFlowConfiguration: function(configuration : FlowConfigurationVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<FlowConfigurationVO>> {
                const uri = `/qsign/api/admin/flowConfigurations`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<FlowConfigurationVO>>(finalUri, configuration, finalConfig);
            },
            getCombinations: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<TypesCombinationVO[]>> {
                const uri = `/qsign/api/admin/getCombinations`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<TypesCombinationVO[]>>(finalUri, finalConfig);
            },
            addSealConnector: function(sealConnectorVO : SealConnectorVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SealConnectorVO>> {
                const uri = `/qsign/api/admin/addSealConnector`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<SealConnectorVO>>(finalUri, sealConnectorVO, finalConfig);
            },
            findSignerByIds: function(ids : number[], config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SignerVO[]>> {
                const uri = `/qsign/api/admin/signers/byIds`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<SignerVO[]>>(finalUri, ids, finalConfig);
            },
            updateTextNote: function(textNoteId : number, textNote : TextNoteVO, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<TextNoteVO>> {
                const uri = `/qsign/api/admin/textnotes/${textNoteId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.put<any, AxiosResponse<TextNoteVO>>(finalUri, textNote, finalConfig);
            },
    }
}
